import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Typography,
  Col,
  Row,
  Tooltip,
} from 'antd';
import styles from '../../../../shared-components/Recipe/recipe.module.sass';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import { InfoCircleFilled } from '@ant-design/icons';
import moment from 'moment-timezone';
import store from '../../../../redux/store';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
import SavedRecipeModal from '../../../../shared-components/SavedRecipeModal';
import useModalNameValidator from '../../../../redux/utils/useModalNameValidator';
import { resetUtilsParseIOCStatus } from '../../../../redux/actions/ioc';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { highlightLeftMenu } from '../../../../redux/actions/leftMenu';
import { Link } from 'react-router-dom';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { validateRecipeDomainName } from '../../../../shared-components/Validation/RecipeDomainName';

function LatestDNSRecordsRecipe(props) {
  mixpanel.track('Global Nav - Latest DNS Records', {
    location: window.location.href,
  });
  const { exploreRecipeLatestDNSRecords } = props;

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  const q = useQuery();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [saveModalType, setSaveModalType] = useState('saveNew');
  const isSaveModalValid = useModalNameValidator(nameOfNewQuery);
  const [isDomainValid, setIsDomainValid] = useState(true);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const { Paragraph, Text, Title } = Typography;
  const titleText = q?.get('left_menu_name') || 'Latest DNS Records';

  useEffect(() => {
    document.title = `${titleText} - Silent Push`;
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.resetRecipeStatus();
    props.clearExploreDetails();
    form.resetFields();

    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeLatestDNSRecords(q?.get('recipeid'));
    }
    dispatch(changeTitle(titleText, null));
  }, []);

  useEffect(() => {
    return () => {
      props.resetUtilsParseIOCStatus();
      setIsSearchEnabled(false);
    };
  }, []);

  useEffect(() => {
    props.resetRecipeStatus();
    form.resetFields();
    setSaveModalType('saveNew');

    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeLatestDNSRecords(q?.get('recipeid'));
    }
    setIsSearchEnabled(false);
  }, [window.location.search]);

  function resetForm() {
    form.resetFields();
    if (q?.get('recipeid')) {
      props.loadMergeAPIExploreRecipeLatestDNSRecords(q?.get('recipeid'));
    }
    setIsSearchEnabled(false);
  }

  useEffect(() => {
    // form.resetFields();
    dispatch(
      changeTitle(
        props?.exploreRecipeLatestDNSRecords?.name ?? titleText,
        null,
      ),
    );
    document.title = `${titleText} - Silent Push`;
    if (
      props.recipeStatusLatestDNSRecords == STATUS.LOADED &&
      props?.exploreRecipeLatestDNSRecords?.name
    ) {
      document.title = `${props?.exploreRecipeLatestDNSRecords?.name} - Silent Push`;
    }
    // }, [props.exploreRecipeLatestDNSRecords]);

    // useEffect(() => {
    if (window.location.href.includes('/explore/latest-dns-records')) {
      if (
        props?.exploreRecipeLatestDNSRecords?.uuid &&
        window.location.href.indexOf(
          '/explore/latest-dns-records?recipeid=' +
            props?.exploreRecipeLatestDNSRecords?.uuid,
        ) == -1
      ) {
        history.push(
          '/explore/latest-dns-records?recipeid=' +
            props?.exploreRecipeLatestDNSRecords?.uuid,
        );
        dispatch(highlightLeftMenu(props?.exploreRecipeLatestDNSRecords?.uuid));
      }
      form.resetFields();
      form.setFieldsValue({
        threat_name: exploreRecipeLatestDNSRecords?.domain,
        subdomains: exploreRecipeLatestDNSRecords?.include_subdomains
          ? 'true'
          : 'false',
        window: exploreRecipeLatestDNSRecords?.window,
      });
    }
  }, [props.exploreRecipeLatestDNSRecords]);

  useEffect(() => {
    if (props.parsedIOCStatus === STATUS.LOADED && isSearchEnabled === true) {
      if (!props?.parsedIOC?.valid) {
        form.validateFields();
        return;
      }
      const last_seen_after = form.getFieldValue('window');
      let ioc = props?.parsedIOC?.result;
      if (form.getFieldValue('subdomains') === 'true') {
        ioc = '*.' + ioc;
      }
      props.history.push(
        `/explore-result?name=${ioc}&queryType=query&type=any` +
          '&last_seen_after=-' +
          (last_seen_after ? last_seen_after : '30') +
          'd&origin_uid=LATEST_DNS_RECORDS&recipe=/explore/latest-dns-records' +
          ((q?.get('recipeid') ? `?recipeid=${q?.get('recipeid')}` : '') ??
            '') +
          '&backLink=' +
          encodeURIComponent(window.location.pathname) +
          encodeURIComponent(window.location.search),
      );
    }
  }, [props.parsedIOCStatus]);

  const handleCancel = () => {
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function changeScopeRecipe() {
    props.changeScopeMergeAPIExploreRecipeLatestDNSRecords({
      scope:
        props?.exploreRecipeLatestDNSRecords?.scope === 'USER'
          ? 'ORGANISATION'
          : 'USER',
      uuid: props?.exploreRecipeLatestDNSRecords?.uuid,
    });
  }

  function returnUiRecipeData(values, type) {
    if (type === 'saveAs') {
      return {
        new_name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeLatestDNSRecords?.name,
        new_description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeLatestDNSRecords?.description,
      };
    } else {
      return {
        name: nameOfNewQuery
          ? nameOfNewQuery
          : exploreRecipeLatestDNSRecords?.name,
        description:
          descriptionOfNewQuery || descriptionOfNewQuery === ''
            ? descriptionOfNewQuery
            : exploreRecipeLatestDNSRecords?.description,
        domain: values?.threat_name,
        query_type: values?.type ? values?.type : 'A',
        include_subdomains: values?.subdomains === 'true',
        window: values?.window ? values.window : '30',
        uuid: q?.get('recipeid'),
      };
    }
  }

  const handleOk = (type) => {
    form
      .validateFields()
      .then((values) => {
        if (saveModalType === 'edit' || type === 'edit') {
          props.updateMergeAPIExploreRecipeLatestDNSRecords(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveNew' || type === 'saveNew') {
          props.saveMergeAPIExploreRecipeLatestDNSRecords(
            returnUiRecipeData(values, type),
          );
        } else if (saveModalType === 'saveAs' || type === 'saveAs') {
          props.cloneRecipe(
            returnUiRecipeData(values, type),
            'latest-dns-record-recipes',
            q?.get('recipeid'),
          );
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
    setIsModalVisible(false);
  };

  function renderPane() {
    return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
      props.mySubscriptionPlan?.has_access_to_latest_dns_records_recipe ? (
        props.recipeStatusLatestDNSRecords !== STATUS.LOADING ? (
          <div className={styles.explore_recipe}>
            <Row gutter={24}>
              <Col xs={24} className={styles.header}>
                <div className={threat_detail_styles['type-chip']}>
                  {titleText}
                </div>

                <div className={styles.recipeDescription}>
                  <Paragraph className="m-0">
                    {exploreRecipeLatestDNSRecords?.description
                      ? exploreRecipeLatestDNSRecords.description
                      : "Explore a list of a domain's DNS records, from the previous 30 days."}{' '}
                  </Paragraph>

                  <Link
                    to={{
                      pathname:
                        'https://help.silentpush.com/docs/explore-a-list-of-a-domains-dns-records',
                    }}
                    target="_blank"
                  >
                    Knowledge Base
                  </Link>
                </div>

                <div className={styles.action_buttons}>
                  {((q?.get('recipeid') &&
                    props?.exploreRecipeLatestDNSRecords?.scope === 'USER') ||
                    (q?.get('recipeid') &&
                      props?.exploreRecipeLatestDNSRecords?.scope ===
                        'ORGANISATION' &&
                      props?.exploreRecipeLatestDNSRecords?.is_mine ===
                        true)) && (
                    <>
                      <Tooltip
                        title={
                          props.mySubscriptionPlan
                            ?.has_access_to_share_unshare ? (
                            ''
                          ) : (
                            <>
                              Sharing option is not part of this subscription
                              plan. To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          )
                        }
                      >
                        <Button
                          disabled={
                            !props.mySubscriptionPlan
                              ?.has_access_to_share_unshare
                          }
                          role={'button1'}
                          onClick={() => changeScopeRecipe()}
                        >
                          {props?.exploreRecipeLatestDNSRecords?.scope ===
                          'ORGANISATION'
                            ? 'Unshare'
                            : 'Share'}
                        </Button>
                      </Tooltip>

                      <Button
                        onClick={() => {
                          setSaveModalType('edit');
                          setIsModalVisible(true);
                        }}
                      >
                        Edit
                      </Button>

                      <Button
                        danger
                        onClick={() => {
                          props.deleteMergeAPIExploreRecipeLatestDNSRecords(
                            q?.get('recipeid'),
                          );
                          props.resetRecipeStatus();
                          props.clearExploreDetails();
                          props.history.push('/explore');
                        }}
                      >
                        Delete
                      </Button>
                    </>
                  )}
                </div>
              </Col>
            </Row>

            <Form
              className={styles.form}
              form={form}
              name="explore"
              initialValues={{
                threat_name: exploreRecipeLatestDNSRecords?.domain,
                subdomains: exploreRecipeLatestDNSRecords?.include_subdomains
                  ? 'true'
                  : 'false',
                window: exploreRecipeLatestDNSRecords?.window,
              }}
              onFinish={(values) => {
                const domain = values?.threat_name?.replace(/[\s\[\]]/g, '');
                props.loadUtilsParseIOC({
                  ioc: domain,
                });
                setIsSearchEnabled(true);
              }}
            >
              <Row gutter={36}>
                <Col xs={24}>
                  <Title level={5}>Domain *</Title>
                </Col>

                <Col xs={24} lg={12}>
                  <Text>Domain Name</Text>
                  <Form.Item
                    name="threat_name"
                    onFocus={(v) => props.resetUtilsParseIOCStatus()}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(fieldObject, fieldValue) {
                          const validation = validateRecipeDomainName(
                            fieldValue,
                            titleText,
                          );

                          if (validation.valid) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject(validation?.message);
                          }
                        },
                      }),
                    ]}
                  >
                    <Input maxLength={255} placeholder="Enter Domain Name" />
                  </Form.Item>
                </Col>

                <Col xs={24} lg={12}>
                  <Text>
                    Subdomains{' '}
                    <Tooltip
                      placement="top"
                      title="Include subdomains in the search result (optional)."
                    >
                      <InfoCircleFilled />
                    </Tooltip>
                  </Text>

                  <Form.Item
                    name="subdomains"
                    rules={[
                      {
                        required: false,
                        message:
                          'Please select if subdomains should be included!',
                      },
                    ]}
                  >
                    <Select
                      options={[
                        { label: 'Exclude', value: 'false' },
                        { label: 'Include', value: 'true' },
                      ]}
                      defaultValue="false"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} lg={12}>
                  <Title level={5}>
                    Last Seen{' '}
                    <Tooltip
                      placement="top"
                      title="Only show records last observed in the selected period. (optional)"
                    >
                      <InfoCircleFilled />
                    </Tooltip>
                  </Title>

                  <Text>Period</Text>
                  <Form.Item
                    name="window"
                    rules={[
                      {
                        required: false,
                        message: 'Please input the window!',
                      },
                    ]}
                  >
                    <Select
                      options={[
                        { label: '30 days', value: '30' },
                        // { label: '60 days', value: '60' },
                        // { label: '90 days', value: '90' },
                      ]}
                      defaultValue="30"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className={styles.bottom_actions}>
                <Form.Item>
                  <Tooltip
                    title={
                      props.mySubscriptionPlan?.has_access_to_explore ? (
                        ''
                      ) : (
                        <>
                          This option is not part of this subscription plan. To
                          upgrade your subscription contact us at{' '}
                          <a target="_blank" href="mailto:sales@silentpush.com">
                            sales@silentpush.com
                          </a>
                          .
                        </>
                      )
                    }
                  >
                    <Button
                      role={'button2'}
                      type="primary"
                      htmlType="submit"
                      disabled={
                        !isDomainValid ||
                        !props.mySubscriptionPlan?.has_access_to_explore
                      }
                      loading={props.parsedIOCStatus === STATUS.LOADING}
                    >
                      Search
                    </Button>
                  </Tooltip>
                </Form.Item>

                <Button
                  role={'button1'}
                  onClick={() => {
                    if (saveModalType === 'saveNew' && !q?.get('recipeid')) {
                      form
                        .validateFields()
                        .then((values) => {
                          setNameOfNewQuery('');
                          setDescriptionOfNewQuery('');
                          setSaveModalType('saveNew');
                          setIsModalVisible(true);
                        })
                        .catch((errorInfo) => {});
                    } else {
                      handleOk('edit');
                    }
                  }}
                >
                  {q?.get('recipeid') ? 'Update Recipe' : 'Save Recipe'}
                </Button>

                {q?.get('recipeid') && (
                  <Button
                    role={'button3'}
                    onClick={() => {
                      setSaveModalType('saveAs');
                      setIsModalVisible(true);
                    }}
                  >
                    Save As
                  </Button>
                )}

                <Button className="ms-05" onClick={() => resetForm()}>
                  Reset Form
                </Button>
              </div>
            </Form>
          </div>
        ) : (
          <LoadingSilentPush size={80} positionCenter />
        )
      ) : (
        <PermissionDeniedPage />
      )
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }

  return (
    <>
      <SavedRecipeModal
        isModalVisible={isModalVisible}
        isSaveModalValid={isSaveModalValid}
        handleOk={handleOk}
        handleCancel={handleCancel}
        nameOfNewQuery={nameOfNewQuery}
        setNameOfNewQuery={setNameOfNewQuery}
        descriptionOfNewQuery={descriptionOfNewQuery}
        setDescriptionOfNewQuery={setDescriptionOfNewQuery}
        type={saveModalType}
        loadedRecipe={exploreRecipeLatestDNSRecords}
      />
      {renderPane()}
      <VersionCheck
        parentComponentStatus={
          q?.get('recipeid')
            ? props.recipeStatusLatestDNSRecords
            : STATUS.LOADED
        }
      />
    </>
  );
}

export default LatestDNSRecordsRecipe;
